/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  key: 2,
  class: "ml_1 mr_1"
};
const _hoisted_3 = {
  style: {
    "overflow": "auto"
  },
  class: "flex grow_1 direction_column"
};
import * as dictionary from "../utils/dictionary";
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'YView',
  props: {
    col: {
      type: Array,
      default: []
    },
    paddingTop: {
      type: String,
      default: "20"
    } //
  },

  setup(__props) {
    const props = __props;
    const $controller = inject("$controller");
    const col = ref(props.col);
    const paddingTop = ref(props.paddingTop);
    let menuPath = ref([]); //存储菜单路径
    let localCacheMenuPath = localStorage.getItem("menuPath");
    if (localCacheMenuPath) {
      menuPath.value = JSON.parse(localCacheMenuPath);
    }
    // // 监控导航   顶部切换的时候，如果非列表 有缓存，也就是 时间戳不变，所以监控下
    window.addEventListener("updateMenuPathEvent", e => {
      let localCacheMenuPath = localStorage.getItem("menuPath");
      if (localCacheMenuPath) {
        menuPath.value = JSON.parse(localCacheMenuPath);
      }
    });
    function onReturnList() {
      $controller.returnList();
    }
    function sty(item, i) {
      const len = props.col.length;
      if (i !== len - 1) {
        return {
          float: "left",
          width: item,
          height: "100%",
          resize: "none",
          overflow: "auto"
        };
      }
      if (item == "auto") {
        return {
          "margin-left": props.col[0],
          height: "100%",
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          display: "flex",
          flexDirection: "column"
        };
      }
      return {};
    }
    setTimeout(() => {
      if (document.querySelector("#add_page_bottom") && !document.querySelector("#add_page_bottom")?.innerHTML) {
        document.querySelector("#view_body").style.marginBottom = "0px";
      }
    }, 200);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass([_ctx.css.vw, {
          [_ctx.css.no_col]: !col.value || !col.value.length
        }])
      }, [col.value && col.value.length ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(col.value, (item, i) => {
        return _openBlock(), _createElementBlock("div", {
          key: i,
          style: _normalizeStyle(sty(item, i))
        }, [_renderSlot(_ctx.$slots, 'col' + i, {
          dic: dictionary
        })], 4);
      }), 128)) : (_openBlock(), _createElementBlock("div", {
        key: 1,
        id: "view_body",
        class: _normalizeClass(["flex direction_column grow_1", [_ctx.css.view_cont, {
          [_ctx.css.view_cont_width_bottom]: _ctx.$slots.bottom
        }]])
      }, [_ctx.$slots.top ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.css.view_cont_top),
        id: "view_cont_top_id"
      }, [_renderSlot(_ctx.$slots, "top", {
        dic: dictionary
      })], 2)) : _createCommentVNode("", true), _createElementVNode("div", {
        class: _normalizeClass([[_ctx.css.view_cont_default, {
          [_ctx.css.view_cont_default_padding_bottom]: _ctx.$slots.bottom
        }], "flex direction_column grow_1"]),
        style: _normalizeStyle('padding-top:' + paddingTop.value + 'px!important')
      }, [_unref(menuPath) && _unref(menuPath).length > 1 && _ctx.$route.path.indexOf('list') == -1 ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.css.path)
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(menuPath), (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: index
        }, [index == 0 ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: _normalizeClass(["pointer text_gray_2", _ctx.css.returnList]),
          onClick: onReturnList,
          title: "返回至列表"
        }, _toDisplayString(item.name), 3)) : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(item.name), 1)), index != _unref(menuPath).length - 1 ? (_openBlock(), _createElementBlock("span", _hoisted_2, "/")) : _createCommentVNode("", true)], 64);
      }), 128))], 2)) : _createCommentVNode("", true), _ctx.$slots.title ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.css.title)
      }, [_renderSlot(_ctx.$slots, "title")], 2)) : _createCommentVNode("", true), _ctx.$slots.step ? _renderSlot(_ctx.$slots, "step", {
        key: 2
      }) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "default", {
        dic: dictionary
      })])], 6), _ctx.$slots.bottom ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.css.bottom),
        id: "add_page_bottom"
      }, [_renderSlot(_ctx.$slots, "bottom")], 2)) : _createCommentVNode("", true)], 2))], 2);
    };
  }
});